import ChecklistIcon from '@mui/icons-material/Checklist';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import { useMaintenanceMode } from '../contexts/MaintenanceContext';
import UserRequests from "./UserRequests";

function Home() {
  const { isMaintenanceMode } = useMaintenanceMode();

  return (
    <div>
      <Grid container alignItems="center">
        <Grid item xs={8}>
          <h2 className="page-title" style={{ margin: '10px', marginTop: '20px' }}>Your Active Resource Requests</h2>
        </Grid>
        <Grid container item xs={4} justifyContent="flex-end">

          <Button
            component={Link}
            to={'/user/resources'}
            variant="contained"
            color="primary"
            startIcon={<ChecklistIcon />}
            disabled={isMaintenanceMode}
            style={{ margin: '10px', marginTop: '20px' }}
          >
            Show my resources
          </Button>
        </Grid>
      </Grid>


      <UserRequests sinceDays={30} showAllResourcesFilter={false} windowed={true} />
    </div>
  );
}

export default Home;